(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('skillService', skillService);

    function skillService($http, $q, $translate, baseUrl, portalUrl, portalIdentifier, tokenService) {
        baseUrl = baseUrl || "";
        return {
            assignSkillToUsers: assignSkillToUsers,
            createIndividualQuality: createIndividualQuality // todo: replace api call
        };

        function assignSkillToUsers(skillId, idStrings) {
            return tokenService.getToken()
                .then(() => $http.put(baseUrl + '/api/6.0/skill/assign-users/' + portalIdentifier, {
                    skillId: skillId,
                    idStrings: idStrings
                }))
                .then(response => {
                    if (angular.isObject(response.data)) {
                        return response.data;
                    } else {
                        return $q.reject(response.data);
                    }
                }, errorResponse => $q.reject(errorResponse.data));
        }

        function createIndividualQuality(id, userId) {
            return tokenService.getToken()
                .then(() => $http.put(baseUrl + '/api/6.0/createIndividualQuality/' + portalIdentifier, {
                    individualSkillId: id,
                    idString: userId
                }))
                .then(response => {
                    if (angular.isObject(response.data)) {
                        return response.data;
                    } else {
                        return $q.reject(response.data);
                    }
                }, errorResponse => $q.reject(errorResponse.data));
        }
    }
})();
